export type NavItem = {
  label: string;
  slug?: string;
};

export type NavSection = {
  title: string;
  items: NavItem[];
};

export const NAV_SECTIONS: NavSection[] = [
  {
    title: "Getting Started",
    items: [
      { label: "Overview" },
      { label: "Authentication", slug: "authentication" },
      { label: "Quick Start", slug: "quick-start" },
      { label: "Creative vs Verbatim Mode", slug: "verbatim-mode" },
    ],
  },
  {
    title: "Connect an assistant (MCP)",
    items: [
      { label: "Connect to Claude", slug: "connect-claude" },
      { label: "Connect to Codex", slug: "connect-codex" },
      { label: "Connect to ChatGPT", slug: "connect-chatgpt" },
    ],
  },
  {
    title: "Personas & Automation",
    items: [
      { label: "Personas and Sessions", slug: "personas-sessions" },
      { label: "Running Platform Actions", slug: "platform-actions" },
      { label: "Routing", slug: "action-routing" },
      { label: "Controlling the Browser", slug: "browser-control" },
      { label: "Action Errors", slug: "action-errors" },
      { label: "Action Reference", slug: "action-reference" },
    ],
  },
  {
    title: "Generation",
    items: [
      { label: "Image Generation", slug: "image-generation" },
      { label: "Video Generation", slug: "video-generation" },
      { label: "Text Generation", slug: "text-generation" },
      { label: "Music Generation", slug: "music-generation" },
      { label: "Speech (TTS)", slug: "audio-speech" },
      { label: "Transcription (STT)", slug: "audio-transcription" },
      { label: "Dialogue", slug: "audio-dialogue" },
      { label: "Extract Timestamps", slug: "alignment-timestamps" },
    ],
  },
  {
    title: "Editing",
    items: [
      { label: "Video Editing", slug: "video-editing" },
      { label: "Image Editing", slug: "image-editing" },
      { label: "Audio Editing", slug: "audio-editing" },
    ],
  },
  {
    title: "Publishing",
    items: [
      { label: "Instagram", slug: "publish-instagram" },
      { label: "TikTok", slug: "publish-tiktok" },
      { label: "Distribution Accounts", slug: "distribution-accounts" },
      { label: "Distribution Publishing", slug: "distribution-publishing" },
    ],
  },
  { title: "Media", items: [{ label: "Upload Media", slug: "media-upload" }] },
  { title: "Analytics", items: [{ label: "Analytics", slug: "analytics" }] },
  { title: "Scraping", items: [{ label: "Scraping", slug: "scraping" }] },
  { title: "Styles", items: [{ label: "List Styles", slug: "styles-list" }] },
  {
    title: "Discovery & Pricing",
    items: [
      { label: "Capabilities", slug: "capabilities" },
      { label: "Pricing", slug: "pricing" },
      { label: "Cost Estimation", slug: "pricing-estimate" },
    ],
  },
  {
    title: "Reference",
    items: [
      { label: "Error Codes", slug: "errors" },
      { label: "Job Polling", slug: "job-polling" },
      { label: "Rate Limits", slug: "rate-limits" },
    ],
  },
];

/** slug -> display title, derived from NAV_SECTIONS */
export const SLUG_TITLES: Record<string, string> = Object.fromEntries(
  NAV_SECTIONS.flatMap((s) => s.items)
    .filter((item): item is NavItem & { slug: string } => !!item.slug)
    .map((item) => [item.slug, item.label]),
);

/** Flat list of all doc slugs, derived from NAV_SECTIONS */
export const DOC_SLUGS: string[] = Object.keys(SLUG_TITLES);
